<ng-container *ngIf="state==='loading'">
  <div class="flex-column-center column-button">
    <mat-progress-spinner
      [class.column-button-spinner]="true"
      diameter="32"
      color="accent"
      [mode]="'indeterminate'">
    </mat-progress-spinner>
  </div>
</ng-container>
<ng-container *ngIf="state==='error'">
  <div class="flex-column-center column-button">
    <mat-icon color="warn">error</mat-icon>
    <div class="nowrap">Error...</div>
  </div>
</ng-container>
<ng-container *ngIf="state==='default'">
  <div *ngIf="listItem['itemFullData']['relation_params']['type']=='friends' && listItem['itemFullData']['relation_params']['action']=='my_approve' && !listItem['itemFullData']['relation_params']['__class']"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'approve_as_friends')">
    <mat-icon>person_add</mat-icon>
    <div>{{'approve_as_friends_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['type']=='friends' && listItem['itemFullData']['relation_params']['status']=='active' && !listItem['itemFullData']['relation_params']['__class']"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'remove_from_friends')">
    <mat-icon>person_remove</mat-icon>
    <div>{{'remove_from_friends_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['type']=='friends' && listItem['itemFullData']['relation_params']['action']=='wait_approve'"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'wait_friend_approval')">
    <mat-icon>info</mat-icon>
    <div>{{'wait_friend_approval_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['action']=='my_approve' && listItem['itemFullData']['relation_params']['__class_owner']"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'approve_in_class')">
    <mat-icon>group_add</mat-icon>
    <div>{{'approve_in_class_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['status']=='active' && listItem['itemFullData']['relation_params']['__class'] && listItem['itemFullData']['relation_params']['__class_owner']"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'remove_from_class')">
    <mat-icon>group_remove</mat-icon>
    <div>{{'remove_from_class_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['status']=='active' && listItem['itemFullData']['relation_params']['__class'] && !listItem['itemFullData']['relation_params']['__class_owner']"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'mutual_class')">
    <mat-icon>info</mat-icon>
    <div>{{'mutual_class_popup_title' | GetLabelPipe}}</div>
  </div>
  <div *ngIf="listItem['itemFullData']['relation_params']['type']=='source_referral' && listItem['itemFullData']['relation_params']['status']=='active'"
       matRipple class="flex-column-center column-button" (click)="relationClick($event, 'my_referral')">
    <mat-icon>info</mat-icon>
    <div>{{'your_referral_title' | GetLabelPipe}}</div>
  </div>
</ng-container>

